// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 1C4.79086 1 3 2.79086 3 5V19C3 21.2091 4.79086 23 7 23H10V21H7.5C6.11929 21 5 19.8807 5 18.5C5 17.1193 6.11929 16 7.5 16H8.96776C9.70411 14.5183 11.2331 13.5 13 13.5C14.7669 13.5 16.2959 14.5183 17.0322 16H19V21H16V23H21V1H7ZM8 5H10.0039V7.00391H8V5ZM8 8H10.0039V10.0039H8V8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.9137 18.3644L12.9998 14.6152L9.08594 18.3644L10.4694 19.8086L11.9998 18.3427V23H13.9998V18.3427L15.5302 19.8086L16.9137 18.3644Z"}}]};

const GitRepositoryCommitsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'git-repository-commits-filled',
    ref,
    icon: element,
  },
));

GitRepositoryCommitsFilledIcon.displayName = 'GitRepositoryCommitsFilledIcon';

export default GitRepositoryCommitsFilledIcon;
